<template>
    <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row no-gutter justify-center items-center">
                        <language></language>
                        <div class="vx-col hidden lg:block lg:w-1/2" style="position: relative;">
                            <div class="p-8">
                                <div  style="margin-bottom: 46px;">
                                    <!--
                                    <img src="@/assets/images/pages/login_logo.svg" width="35%" style="display: inline-block">
                                    <a href="https://techprodc.com/about" target="_blank" rel="nofollow" style="display: inline-block;float: right;width: 55%;">
                                        <img src="@/assets/images/logo/made_with_new2.svg" width="100%">
                                    </a>
                                    -->
                                    <a href="https://techprodc.com/about" target="_blank" rel="nofollow" style="display: inline-block;float: left;width: 55%;">
                                        <img src="@/assets/images/logo/made_with_new2.svg" width="100%">
                                    </a>
                                    <br>
                                </div>
                                <span v-html="$t('login_esd_desc')"></span>
                                <br><br>

                                <vs-button to="/pages/become-a-partner" class="w-full sm:w-auto sm:mb-auto mt-3 sm:mt-auto">{{ $t('BecomePartner') }}</vs-button>
                            </div>
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">{{ $t('login') }}</h4>
                                    <p>{{ $t('loginDesc') }}</p>
                                </div>

                                <div>Email</div>
                                <vs-input
                                    v-validate="'required|email|min:3'"
                                    data-vv-validate-on="blur"
                                    name="email"
                                    icon="icon icon-user"
                                    icon-pack="feather"
                                    v-model="email"
                                    @keyup.enter="login"
                                    class="w-full no-icon-border"/>
                                <span class="text-danger text-sm">{{ errors.first('email') }}</span>

                                <div class="mt-6">{{ $t('password') }}</div>
                                <vs-input
                                    data-vv-validate-on="blur"
                                    v-validate="'required|min:6'"
                                    type="password"
                                    name="password"
                                    icon="icon icon-lock"
                                    icon-pack="feather"
                                    v-model="password"
                                    @keyup.enter="login"
                                    class="w-full no-icon-border"/>
                                <span class="text-danger text-sm">{{ errors.first('password') }}</span>

                                <div class="flex flex-wrap justify-between my-5">
                                    <vs-checkbox v-model="checkbox_remember_me" class="mb-3">&nbsp;{{ $t('RememberMe') }}</vs-checkbox>
                                    <router-link to="/pages/forgot-password">{{ $t('ForgotPassword') }}</router-link>
                                </div>

                                <div class="flex flex-wrap justify-between sm:flex-row">
                                    <vs-button class="w-full sm:w-auto" :disabled="!validateForm" @click="login">{{ $t('login') }}</vs-button>
                                    <vs-button to="/pages/become-a-partner" class="w-full sm:w-auto sm:mb-auto mt-3 sm:mt-auto sm:block md:block lg:hidden">{{ $t('BecomePartner') }}</vs-button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
    import Language from "../components/Language";

    export default {
        components: {
            Language,
        },
        data() {
            return {
                email: '',
                password: '',
                checkbox_remember_me: false
            }
        },
        computed: {
            validateForm() {
                return !this.errors.any() && this.email != '' && this.password != '';
            },
        },
        methods: {
            login() {
                // Loading
                this.$vs.loading();

                const payload = {
                    checkbox_remember_me: this.checkbox_remember_me,
                    userDetails: {
                        email: this.email,
                        password: this.password
                    },
                    notify: this.$vs.notify,
                    closeAnimation: this.$vs.loading.close
                };
                this.$store.dispatch('auth/loginAttempt', payload);
            },
        }
    }
</script>

<style lang="scss" scoped>
    .login-background{
        position:absolute;width: 50%;height: 100%;background: #fff;left: 0;top: 0;opacity: 0.8;z-index: 1;
    }
    @media (max-width: 992px){
        .login-background{
            position:absolute;width: 0;height: 0;left: 0;top: 0;
        }
    }
</style>
